import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../stores/appStore';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const Footer = () => {
  const { t } = useTranslation();
  const { isOffline, connectionStatus } = useAppStore();

  return (
    <footer className="bg-white border-t border-gray-200 safe-area-bottom">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between text-sm text-gray-500">
          {/* Left: App Info */}
          <div className="flex items-center space-x-4">
            <span>© {new Date().getFullYear()} PRO-Act</span>
            <span className="hidden sm:inline">
              by Siete.Online
            </span>
          </div>

          {/* Center: Status */}
          <div className="flex items-center space-x-2">
            {isOffline ? (
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse" />
                <span className="text-red-600 text-xs">
                  {t('app.offline')}
                </span>
              </div>
            ) : connectionStatus === 'reconnecting' ? (
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" />
                <span className="text-yellow-600 text-xs">
                  {t('app.reconnecting')}
                </span>
              </div>
            ) : (
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-green-400 rounded-full" />
                <span className="text-green-600 text-xs">
                  Online
                </span>
              </div>
            )}
          </div>

          {/* Right: Last Updated */}
          <div className="text-xs text-gray-400 hidden sm:block">
            {format(new Date(), 'HH:mm', { locale: es })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;